export function formControlState({
  props,
  states,
  factorFormControl,
}: {
  props: any
  states: any
  factorFormControl: any
}) {
  return states.reduce((acc: any, state: any) => {
    acc[state] = props[state]
    if (factorFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = factorFormControl[state]
      }
    }
    return acc
  }, {})
}
